import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { attachment } from './attachment.model';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AttachmentComponent {
  @Input() transmission: string;
  readonly MAX_TEXT_ATTACHMENT_SIZE = 600 * 1024; // 600 KB

  uploadProgress: number;
  uploadSub: Subscription;
  apiHost: string = environment.apiHost;
  isLoading: boolean = false;
  counter: number = -1;
  fileName: string[] = [];
  fileUrl: string[] = [];
  attachments: attachment[] = [];
  fileError: string = '';

  constructor(private fileUploadService: fileUploadService) { }

  async onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];

  this.fileError = '';

  if (!file) return;

  if (
    this.transmission === 'TEXT' &&
    !this.isValidTextAttachment(file)
  ) {
    this.fileError =
      'This file type is not supported for text messages.';
    input.value = '';
    return;
  }

  if (!this.isValidFileSize(file)) {
    this.fileError =
      `The attachment is too large. Text message attachments must be ${this.maxTextAttachmentSizeKB} KB or smaller.`;
    input.value = '';
    return;
  }

  // TEXT messages allow only one attachment.
  // Replace the existing attachment with the new one.
  if (this.transmission === 'TEXT') {
    this.fileName = [];
    this.fileUrl = [];
    this.attachments = [];
    this.counter = -1;
  }

  this.counter++;
  this.isLoading = true;

  try {
    this.fileUrl[this.counter] =
      await this.fileUploadService.uploadFile(
        file,
        file.name,
        'attachments'
      );

    this.fileName[this.counter] = file.name;
  } finally {
    this.isLoading = false;
    input.value = '';
  }
}

  get acceptedFileTypes(): string {
    if (this.transmission === 'TEXT') {
      return [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.bmp',
        '.amr',
        '.midi',
        '.mid',
        '.wav',
        '.ac3',
        '.mp3',
        '.3gp',
        '.mp4',
        '.avi',
        '.mpg',
        '.vcard',
        '.vcf'
      ].join(',');
    }

    // EMAIL
    return '';
  }

  isValidTextAttachment(file: File): boolean {
    const allowedExtensions = [
      'png', 'jpg', 'jpeg', 'gif', 'bmp',
      'amr', 'midi', 'mid', 'wav', 'ac3', 'mp3',
      '3gp', 'mp4', 'avi', 'mpg',
      'vcard', 'vcf'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(extension);
  }

  isValidFileSize(file: File): boolean {
    if (this.transmission !== 'TEXT') {
      return true;
    }

    return file.size <= this.MAX_TEXT_ATTACHMENT_SIZE;
  }

  get maxTextAttachmentSizeKB(): number {
    return Math.round(this.MAX_TEXT_ATTACHMENT_SIZE / 1024);
  }

clearAttachments() {
  this.attachments = [];
  this.fileName = [];
  this.fileUrl = [];
  this.counter = -1;
  this.fileError = '';
}

  getAttachments(): attachment[] {
    let counter: number = 0;
    this.attachments = [];
    this.fileName.forEach((a) => {
      let attach: attachment = new attachment();
      attach.fileName = a;
      attach.fileUrl = this.fileUrl[counter];
      counter = counter + 1;
      this.attachments.push(attach);
    });
    return this.attachments;
  }
}
